import { useEffect, useState } from "react";
import { Button, Modal, ModalBody, Table } from "reactstrap";
import ordemServicoService from "services/OrdemServicoService";
import { formatNumber } from "services/Utils";
import { formatDateTime } from "services/Utils";

export default function ModalHistorico({ config, onClosed }) {
  const [itens, setItens] = useState([])

  useEffect(() => {
    if (config) {
      ordemServicoService.getHistoricoItem(config.idOrdemServico, config.selecionado.id).then(res => {
        if (res.success) {
          setItens(res.data)
        }
      })
    } else {
      setItens([])
    }
  }, [config?.idOrdemServico, config?.selecionado])

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        {config && (
          <>
            <h2>Histórico de Alterações</h2>
            <hr />
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Data</th>
                  <th scope="col">Usuário</th>
                  <th scope="col">Descrição</th>
                  <th scope="col" className="text-right">Quant. Ant.</th>
                  <th scope="col" className="text-right">Nova Quant.</th>
                </tr>
              </thead>
              <tbody>
                {itens.map(el => (
                  <tr key={el.id}>
                    <td>{el.dataFmt}</td>
                    <td>{el.usuario}</td>
                    <td>{el.descricao}</td>
                    {!!el.detalhes ? (
                      <>
                        <td className="text-right">{!!el.detalhes.quantidadeAnterior ? formatNumber(el.detalhes.quantidadeAnterior) : '-'}</td>
                        <td className="text-right">{formatNumber(el.detalhes.quantidade)}</td>
                      </>
                    ) : (
                      <>
                        <td className="text-right">-</td>
                        <td className="text-right">-</td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="row">
              <div className="col-12 text-right">
                <Button color="primary" onClick={onClosed} outline>Fechar</Button>
              </div>
            </div>

          </>
        )}
      </ModalBody>
    </Modal>
  )
}